// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3YuyD","label":"CategoryService_label__rel57","location":"CategoryService_location__hPTyY"};